<template>
  <div class="upload">
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-upload"
      @click="childclick"
    >
      {{ this.buttonName }}
    </el-button>
    <div class="uploadTip" v-show="uploadHide">
      <div class="head">
        <p>文件上传</p>
        <p>
          <i class="el-icon-close" @click="handelClose"></i>
        </p>
      </div>
      <!-- <form enctype="multipart/form-data" ref='fileForm'>
        <input type="file" ref="upFile" name="files" multiple="multiple">
      </form>-->
      <div v-if="this.fileType">
        <p>允许上传文件类型{{ this.fileType }}</p>
      </div>
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="actionUrl()"
        fileData
        :before-remove="removeList"
        :data="fileData"
        :on-exceed="handleExceed"
        :on-success="handleSuccess"
        :on-change="checkType"
        :limit="fileNum ? fileNum : 1"
        :multiple="false"
        :file-list="fileList"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :accept="accept"
      >
        <el-button class="file-btton" slot="trigger" size="small" type="primary"
          >选取文件</el-button
        >
      </el-upload>
      <div class="foot">
        <div class="btn">
          <!-- <ps-sure @click.native="submitUpload"></ps-sure> -->
          <el-button type="primary" size="mini" @click="submitUpload"
            >上传</el-button
          >
          <!-- <ps-cancel @click.native="handelClose"></ps-cancel> -->
          <el-button class="mar-r" type="info" size="mini" @click="handelClose"
            >关闭</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import {ImportantDoc} from '@/service/ImportantDoc';
import { ImportantDoc } from '@/service/PropertyContractRecordController/ImportantDocList';
import { devEnvironment, proEnvironment, baseUrl } from '@/assets/js/division';
export default {
  computed: {
    ...mapState(['token']),
  },
  props: {
    fileType: [Number, String, Array], //允许上传的类型  组件显示文本
    mid: [Number, String, Array], //允许上传的类型  由调用处传参 决定
    configStr: Object,
    idx: Number,
    KeyId: String,
    buttonName: {
      type: String,
      default: '上传',
    },
    fileNum: Number,
    action: {
      type: String,
      default: '',
    },
    isUpload: {
      type: Boolean,
      default: false,
    },
    accept: String,
    isFileUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadHide: false,
      fileList: [],
      resList: [],
      typeArr: [],
      baseURL: baseUrl(),
      fileData: {
        token: '',
        file: null,
        fileType: '',
        fileName: '',
      },
    };
  },
  watch: {},
  created() {
    // this.ImportantDoc=new ImportantDoc();
  },
  mounted() {
    if (this.configStr) {
      this.typeArr = this.configStr.Typeexts.split(';');
    }
  },
  methods: {
    actionUrl() {
      return this.baseURL + 'ImportantWeixinFaqDoc.svt/uploadCommonFaq';
    },
    childclick() {
      this.uploadHide = true;
    },
    submitUpload(val) {
      this.$refs.upload.submit();
    },
    handleSuccess(res, file, fileList) {
      this.$message({
        type: 'success',
        message: '上传成功',
      });
      console.log('res', res);
      console.log('file', file);
      console.log('fileList', fileList);
      this.$emit('uploadSuccess', res, file, fileList);
      this.handelClose();
      this.fileList = fileList;
    },
    handelClose() {
      this.uploadHide = false;
      this.$emit('hclose');
    },
    fileUp(file) {
      this.$refs.upload.submit();
      this.$emit('click', file);
      return false;
    },
    removeList(file) {
      this.$emit('removeFile', this.configStr);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.fileNum ? this.fileNum : 1}个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeUpload(file) {
      this.fileData.token = this.token;
      this.fileData.file = file;
      this.fileData.fileType = 'pdf';
      this.fileData.fileName = file.name;
      if (this.accept) {
        const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
        const whiteList = this.accept
          .split(',')
          .map((item) => item.substring(1));
        if (whiteList.indexOf(fileSuffix) === -1) {
          this.$message.error(`上传文件只能是${this.accept}格式`);
          return false;
        }
      }
    },
    checkType(file) {
      let size = this.configStr.MaxSize.substring(
        0,
        this.configStr.MaxSize.length - 1
      );
      let unit = this.configStr.MaxSize.substring(
        this.configStr.MaxSize.length - 2,
        this.configStr.MaxSize.length
      );
      if (unit === 'MB') {
        size = parseInt(size) * 1024 * 1024;
      } else if (unit === 'KB') {
        size = parseInt(size) * 1024;
      }
      if (size <= file.size) {
        this.fileList = [];
        return this.$message({
          type: 'warning',
          message: '超出文件大小限制！',
        });
      }
      if (this.typeArr.length > 0) {
        let temp = file.name.split('.');
        let typeStr = temp[temp.length - 1].toLowerCase();
        for (const type of this.typeArr) {
          if (type.toLowerCase().indexOf(typeStr) >= 0) return;
        }
        this.fileList = [];
        this.$message({
          type: 'warning',
          message: '不支持该类型文件',
        });
      }
    },
  },
};
</script>
<style lang="scss">
.el-upload--text {
  width: 100%;
  margin-top: 10px;
}
.uploadTip {
  .el-upload-list--text {
    height: 90px !important;
    overflow: scroll !important;
  }
}
</style>

<style lang="scss" scoped>
.upload {
  display: inline-block;
  margin: 0 10px 0 5px;
  .file-btton {
    width: 90%;
  }
  .uploadTip {
    height: 200px;
    width: 400px;
    background: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -100px;
    margin-left: -200px;
    border: 1px solid #ccc;
    z-index: 100;
    border-radius: 10px;
    overflow: hidden;
    .head {
      line-height: 30px;
      height: 30px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      background: #f3f5f9;
    }
    .foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #f3f5f9;
      .btn {
        float: right;
        .mar-r {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
